import styled, { css } from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import ModalAntd from '@deprecated-ui/common/Modal';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';

const Modal = styled(ModalAntd)`
  .ant-modal-content {
    border-radius: 3px;

    .ant-modal-close {
      top: 20px;
      right: 20px;
    }

    .ant-modal-close-x {
      width: 30px;
      height: 30px;
      line-height: 30px;

      @media ${device.tablet} {
        width: 40px;
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .ant-modal-header {
    border-radius: 6px 6px 0 0;

    #header-illustration {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 6px 6px 0 0;

      @media ${device.mobile} {
        height: 200px;
      }

      @media ${device.tablet} {
        height: 300px;
      }
    }
  }

  .ant-modal-body {
    padding: 0;
    margin-top: -24px;

    @media ${device.tablet} {
      margin-top: -36px;
      margin-bottom: 2px;
    }

    img#offering-illustration {
      width: 100%;
    }
  }

  .ant-modal-footer {
    display: flex;
    justify-content: center;
    flex-direction: row;
    padding: 20px;
    flex-direction: column;
    gap: 10px;

    @media ${device.tablet} {
      padding: 40px;
      flex-direction: row;
      gap: 20px;
    }

    button {
      width: 200px !important;
      padding: 7px 15px 8px 15px;
    }
  }
`;

const OfferingContainer = styled(Flex).attrs({
  direction: 'column',
  justify: 'center',
  align: 'center',
})`
  width: 100%;
`;

const TextContainer = styled.div``;

const TitleText = styled.h5`
  margin: 0;
  padding: 0;
  font-weight: 700;
  font-size: 20px;
  line-height: 140%;
  color: ${color.highempahis};
  text-align: center;

  @media ${device.tablet} {
    font-size: 28px;
  }
`;

const UnderlinedText = styled.span`
  border-bottom: 2px solid ${color.primary};
`;

interface IButtonOffer {
  isActive: boolean;
}

const ButtonOffer = styled.div<IButtonOffer>`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 20px 8px 20px 8px;

  border: 1px solid ${color.downgray};
  border-radius: 8px;
  position: relative;

  img.star-left {
    position: absolute;
    top: 0;
    left: 0;
  }

  img.star-right {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  @media ${device.tablet} {
    padding: 30px 12px 30px 16px;
    min-height: 124px;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      border-color: #ffffff;
      background: #ebf8f3;
    `}
`;

const ButtonTextContainer = styled.div`
  color: ${color.highempahis};
  gap: 4px;
`;

const ButtonTitle = styled.h6`
  font-weight: 700;
  font-size: 15px;
  line-height: 135%;
  margin: 0;
  padding: 0;

  @media ${device.tablet} {
    font-size: 18px;
  }
`;

const ButtonDescription = styled.p`
  font-weight: 400;
  font-size: 10px;
  line-height: 18px;
  margin: 0;
  padding: 0;

  @media ${device.tablet} {
    font-size: 13px;
  }
`;

export {
  Modal,
  OfferingContainer,
  TextContainer,
  TitleText,
  UnderlinedText,
  ButtonOffer,
  ButtonTextContainer,
  ButtonTitle,
  ButtonDescription,
};
